import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { StorageService } from './../../providers/storage.service';
import { ToastService } from './../../providers/toast.service';
import { TransferRecordService } from './../../services/transferRecord.service';
import { TransferRecordModel } from './../../models/transferRecord.model';
import { LoaddingService } from './../../providers/loadding.service';
import { PageDefault } from '../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { TransferSearch } from './transfersearch';



@Component({
  selector: 'page-transfer-record',
  templateUrl: 'transfer-record.html',
  providers: [TransferRecordService]
})
export class TransferRecordPage {

  constructor(
    public storage: StorageService,
    public transferRecordService: TransferRecordService,
    private loadding: LoaddingService,
    private modalCtrl: ModalController,
    private toast:ToastService
  ) { }
  records: TransferRecordModel[]=[];
  excludeTracks = [];
  isHave: boolean = false;
  username = this.storage.read<UserModel>("User").UserName;
  site = new TransferSearchInput();
  amount: number;
  pagesize:number=PageDefault.PageSize();
  hasmore:boolean=false;
  //查询点击事件
  record(obj) {
    return this.transferRecordService.getTransferRecord(obj.UserName, obj.StartDate, obj.EndDate, obj.PageSize, obj.PageIndex).then(s => {

       if (s.List != null) {
        if (obj.pageIndex == 1) {
          this.records = [];
          this.records = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.records = this.records.concat(s.List);
          if (this.records.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            obj.pageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.records = [];
      }
      if (this.records.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
    });
  }

  //查询条件
  presentFilter() {
    let modal = this.modalCtrl.create(TransferSearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.site.UserName = this.username;
        this.site.StartDate = this.excludeTracks["startDate"];
        this.site.EndDate = this.excludeTracks["endDate"];
        this.site.PageIndex = this.excludeTracks["pageIndex"];        
        this.record(this.site);
      }
    });
  }

  //页面加载
  ionViewDidLoad() {
    let load = this.loadding.showLoding("加载中..");
    this.site.UserName = this.username;  
    this.record(this.site).then(s => {
      this.loadding.closeLoading(load);
    });
  }


  //下拉重新加载
  //TQQ 2016-12-29
  doRefresh(refresher) {
    this.site.PageIndex = 1;
    this.record(this.site).then(s => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2016-12-29
  doInfinite(infiniteScroll) {
    this.site.PageIndex++;
    this.record(this.site).then(s => {
      infiniteScroll.complete();
    });
  }
  
}

export class TransferSearchInput {
  UserName: string;
  StartDate: string = PageDefault.startDate();
  EndDate: string = PageDefault.endDate();
  PageIndex: number = 1;
  PageSize: number = PageDefault.PageSize();
}




// WEBPACK FOOTER //
// ./src/pages/transfer-record/transfer-record.ts